<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SaRequestForm :propsSaNo="saNo" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SaRequestForm from '@/components/organisms/terminal/form/SaRequestForm'

export default {
  name: 'SaRequestPage',

  components: {
    SaRequestForm,
  },

  data() {
    return {
      saNo: '',
    }
  },

  created() {
    // 検査データ入力から遷移可能なため、削除しない
    const query = this.$route.query
    if (query.saNo) {
      this.saNo = query.saNo
    }
  },
}
</script>
